import { slideDown, slideToggle } from '../../components/utilities';

export default function accordionsFaq() {
  var collapseWrapper;
  var contentWrapper;
  var content;
  var collapses = document.querySelectorAll('[data-collapse]');
  var urlCollapseId = document.location.hash;

  if (urlCollapseId && collapses.length > 0) {
    collapseWrapper = document.querySelector(urlCollapseId);

    if (collapseWrapper) {
      contentWrapper = collapseWrapper.querySelector('.content-wrapper');
      content = collapseWrapper.querySelector('.content');

      collapseWrapper.classList.add('-open');

      window.scrollTo({
        top: contentWrapper.offsetTop - 300,
        behavior: 'smooth',
      });

      slideDown(contentWrapper, content, 300);
    }
  } else if (collapses.length > 0 && !collapses[0].hasAttribute('data-start-closed')) {
    contentWrapper = collapses[0].querySelector('.content-wrapper');
    content = collapses[0].querySelector('.content');

    collapses[0].classList.add('-open');
    slideDown(contentWrapper, content, 0);
  }

  var collapseButtons = document.querySelectorAll('[open-collapse]');

  collapseButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      collapseWrapper = button.closest('[data-collapse]');
      contentWrapper = collapseWrapper.querySelector('.content-wrapper');
      content = collapseWrapper.querySelector('.content');

      collapseWrapper.classList.toggle('-open');
      slideToggle(contentWrapper, content, 300);
    });
  });
}
